import axios from 'axios';
const CONTROLLER_PATH = 'DeprecatedAccount/';
class DeprecatedAccountService {
    getSet(accountIds) {
        return axios.post(CONTROLLER_PATH + 'GetAccounts', accountIds).then((response) => response.data);
    }
    getAgeingAccounts() {
        return axios.get(CONTROLLER_PATH + 'GetAgeingAccounts').then((response) => response.data);
    }
}

export default new DeprecatedAccountService();
